import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "./components/Pages/publicRoutes/auth/login/Login.jsx";
import { Register } from "./components/Pages/publicRoutes/auth/Register.jsx";
import Auth from "./components/Auth/Auth.jsx";
import { DashboardComponent } from "./components/Pages/protectedRoutes/Dashboard.jsx";
import { TestComponent } from "./components/Pages/protectedRoutes/test.jsx";
import store from "./store.js";

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import Unauthorized from "./components/Pages/publicRoutes/Unauthorized.jsx";
import NotFound from "./components/Pages/publicRoutes/NotFound.jsx";
import RouteLayout from "./components/Layout/RouteLayout.jsx";
import "./App.css";
import { expiredSession, fetchUser } from "./redux/authSlice.js";

function App() {
  const ROLES = {
    ADMIN: "ADMIN",
    ASSISTANT_ADMIN: "ASSISTANT_ADMIN",
    OWNER: "OWNER",
    EMPLOYEE: "EMPLOYEE",
    USER: "USER",
    TESTER: "TESTER",
    DEVELOPER: "DEVELOPER",
  };

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    dispatch(fetchUser());
    // .unwrap()
    // .then((data) => console.log("Fetched token:", data.token))
    // .catch(() => console.log("User not authenticated on page load"));
  }, [dispatch]);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<RouteLayout />}>
        <Route path="/" index element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="dashboard"
          element={
            <Auth allowedRoles={Object.values(ROLES)}>
              <DashboardComponent />
            </Auth>
          }
        />
        <Route
          path="test"
          element={
            <Auth allowedRoles={Object.values(ROLES)}>
              <TestComponent />
            </Auth>
          }
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    )
  );

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
